/**
 * Skeleton loading components
 */

export function AgentCardSkeleton() {
  return (
    <div className="bg-[var(--tg-theme-secondary-bg-color)] rounded-xl p-4">
      <div className="flex gap-3">
        <div className="flex-shrink-0 w-12 h-12 rounded-xl skeleton-shimmer" />
        <div className="flex-1 min-w-0">
          <div className="flex items-start justify-between gap-2 mb-2">
            <div className="h-5 skeleton-shimmer rounded w-32" />
            <div className="h-5 skeleton-shimmer rounded-full w-16" />
          </div>
          <div className="h-4 skeleton-shimmer rounded w-full mb-1" />
          <div className="h-4 skeleton-shimmer rounded w-3/4 mb-2" />
          <div className="h-6 skeleton-shimmer rounded w-16" />
        </div>
      </div>
    </div>
  );
}

export function CollectionCardSkeleton() {
  return (
    <div className="flex-shrink-0 w-32 h-24 rounded-xl skeleton-shimmer" />
  );
}

export function SpotlightSkeleton() {
  return (
    <div className="rounded-2xl overflow-hidden skeleton-shimmer h-40" />
  );
}

export function HomeSkeleton() {
  return (
    <div className="space-y-4">
      {/* Collections skeleton */}
      <div>
        <div className="h-6 skeleton-shimmer rounded w-28 mb-2" />
        <div className="flex gap-3 overflow-hidden">
          <CollectionCardSkeleton />
          <CollectionCardSkeleton />
          <CollectionCardSkeleton />
        </div>
      </div>
      {/* Cards skeleton */}
      <div className="space-y-3">
        <AgentCardSkeleton />
        <AgentCardSkeleton />
        <AgentCardSkeleton />
      </div>
    </div>
  );
}
